import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { getRawUrlObj } from '@/common/ts/utils';


export type userInfoType = Record<"uid" | "uname" | "vname" | "serverId" | "serverName" | "roleId" | "roleName" | "roleLevel" | "mid" | "p_mid" | "os" | "device_id" | "gamePid" | "gameGid", string>

type Taction = {
    save: any;
    clear(): void;
    data: any;
}

const INIT_USER_INFO: userInfoType = {
    // pid: '1003',
    // gid: '100005',
    mid: '10000',
    p_mid: '1',
    os: '',
    device_id: '',
    uid: '',
    uname: '',
    vname: '',


    serverId: '',
    serverName: '',
    roleId: '',
    roleName: '',
    roleLevel: '',
    gamePid: '',
    gameGid: ''
}

const INIT_TOKEN: { val: string; expires: number } = {
    val: '',
    expires: 0
}

export const useUserStore = defineStore(
    'userStore',
    () => {
        // token 相关
        const tokenObj = reactive({ ...INIT_TOKEN });
        const token = computed<string>(() => {
            if (tokenObj.expires && tokenObj.expires < Date.now()) {
                tokenAction.clear()
                return '';
            }
            return tokenObj.val || (getRawUrlObj() as any).token || '';
        })

        const tokenAction = reactive<Taction>({
            save(inToken: string, expiresTime?: number) {
                tokenObj.val = inToken;
                if (expiresTime) {
                    tokenObj.expires = Date.now() + expiresTime * 1000;
                }
            },
            clear() {
                Object.assign(tokenObj, INIT_TOKEN);
            },
            data: token,
        });

        const defaultSocialParam = {
            apple_app_id: '',
            apple_client_id: '',
            facebook_appid: '',
            facebook_client_token: '',
            google_client_id: '',
            google_client_key: '',
        }
        const socialParam = reactive({ ...defaultSocialParam });
        const socialParamAction = reactive<Taction>({
            save(inSocialParam: Partial<typeof defaultSocialParam>) {
                Object.entries(inSocialParam).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        (socialParam as any)[key] = value;
                    }
                });
            },
            clear() {
                Object.assign(socialParam, defaultSocialParam);
            },
            data: socialParam,
        });


        // userInfo 相关
        const userInfo = reactive<userInfoType>({ ...INIT_USER_INFO });
        const userInfoAction = reactive<Taction>({
            save(inUserInfo: Partial<userInfoType>) {
                Object.entries(inUserInfo).forEach(([key, value]) => {
                    if (value !== undefined || value !== null) {
                        (userInfo as any)[key] = value;
                    }
                });
            },
            clear() {
                Object.assign(userInfo, INIT_USER_INFO);
            },
            data: userInfo
        });

        return {
            tokenObj,
            token,
            tokenAction,
            socialParam,
            socialParamAction,
            userInfo,
            userInfoAction
        };
    },
    {
        persist: {
            enabled: true,
            strategies: [
                { key: 'userStore', storage: localStorage, paths: ['userInfo', 'tokenObj'] },
            ],
        }
    }
);